// client/components/ui/useIsMobile.js
import { useResponsive } from "../../hooks/useResponsive.js";

/**
 * Hook zur Erkennung von Mobile-Geräten
 * Breakpoint: md (768px) - unterhalb = Mobile
 * 
 * Verwendung:
 * import { useIsMobile } from './useIsMobile';
 * const isMobile = useIsMobile();
 */
export function useIsMobile() {
  return useResponsive().isMobile;
}

export default useIsMobile;
